module.exports = __webpack_public_path__ + "img/20210701_120229.4493d450.jpg";